import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import webSocketManager from '../../service/WebSocketManager';

/**
 * useConsumerCardGenerationSocketStats
 * @param {string} projectId
 * @param {object} actions - { onCreated, onGeneratingStart, onGeneratingFinish, onImageGenerated }
 */
function useConsumerCardGenerationSocketStats(selector, promptType, actions) {
  const { projectName, projectPassword } = useSelector(selector);

  const handleCreated = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onCreated(frameId);
    },
    [actions],
  );

  const handleGeneratingStart = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onGeneratingStart(frameId);
    },
    [actions],
  );

  const handleGeneratingFinish = useCallback(
    (message) => {
      const frameId = message.body;
      actions.onGeneratingFinish(frameId);
    },
    [actions],
  );

  const handleImageGenerated = useCallback(
    (message) => {
      const { bucketId, imageId } = JSON.parse(message.body);
      actions.onImageGenerated({ bucketId, imageId });
    },
    [actions],
  );

  const handleAllImagesGenerated = useCallback(() => {
    actions.onAllImagesGenerated();
  }, [actions]);

  useEffect(() => {
    if (!projectName || !projectPassword) return;

    const stompClient = webSocketManager.getConsumerProjectConnection({ projectName, projectPassword });

    stompClient.onConnect = () => {
      stompClient.subscribe(
        `/id8/content/generating/start/${projectName}/${projectPassword}/${promptType}`,
        handleGeneratingStart,
      );
      stompClient.subscribe(
        `/id8/content/generating/finish/${projectName}/${projectPassword}/${promptType}`,
        handleGeneratingFinish,
      );
      stompClient.subscribe(`/id8/content/image/${projectName}/${projectPassword}/${promptType}`, handleImageGenerated);
      stompClient.subscribe(
        `/id8/content/global/prompt/generating/finish/${projectName}/${projectPassword}/${promptType}`,
        handleAllImagesGenerated,
      );
    };
  }, [
    projectName,
    projectPassword,
    promptType,
    handleCreated,
    handleGeneratingStart,
    handleGeneratingFinish,
    handleImageGenerated,
    handleAllImagesGenerated,
  ]);
}

export default useConsumerCardGenerationSocketStats;
